module.exports = __webpack_public_path__ + "static/media/3pl-solution-banner.4fcfafa8.png";